export default __webpack_public_path__ + "static/media/no_message_blast.36e9a265.svg";